import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Label,
  Row,
  Col,
} from "reactstrap";
import RequestEngine from "../../core/RequestEngine";
import CoreEngine from "../../core/CoreEngine";
import ImageUpload from "../../components/CustomUpload/ImageUpload";
import ButtonLoader from "../../components/ButtonLoader/ButtonLoader";
import SelectRow from "../../components/Select/SelectRow";
import FormRow from "../../components/Row/FormRow";
import { AvForm } from "availity-reactstrap-validation";
import strings from "../../core/translate";
import { Utilites } from "../../core/Utilites";

export default class OfferAddUpdate extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      id: "",
      merchantlist: [],
      merchantId: "",
      branchlist: [],
      branchId: "",
      name: "",
      description: "",
      imageUrl: "",
      isImageChanged: false,
      loading: false,
    };
    this.pathname = "offers";
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const edit = this.props.location.data;

    // If we are editing an existing offer, set the state accordingly
    if (edit) {
      this.setState({
        ...edit,
      });
    }

    // Check if merchantId is stored in sessionStorage
    const storedMerchantId = sessionStorage.getItem("merchantId");

    if (storedMerchantId) {
      // If there's a merchantId in session, use it and fetch branches
      this.setState({ merchantId: storedMerchantId }, () => {
        this.fetchBranches(storedMerchantId);
      });
    } else {
      // Otherwise, fetch the merchants and allow the user to select
      this.prepareData();
    }
  }

  async prepareData() {
    try {
      let responseuni = await this.engine.getItemlistDirect("merchants");
      if (responseuni) {
        const data = responseuni.data.items;
        let merchantlist = data.map((p) => ({ value: p.id, label: p.name }));

        // Set the list of merchants
        this.setState({ merchantlist });

        // If no merchant is selected, automatically select the first one
        if (!this.state.merchantId && merchantlist.length > 0) {
          const firstMerchantId = merchantlist[0].value;
          this.setState({ merchantId: firstMerchantId }, () => {
            this.fetchBranches(firstMerchantId); // Fetch branches for the first merchant
          });
        }
      }
    } catch (error) {
      console.error("Error fetching merchants:", error);
    }
  }

  async fetchBranches(merchantId) {
    try {
      const responseuni = await this.engine.getItemlistDirect(
        `merchants/${merchantId}/branches`
      );
      if (responseuni) {
        const data = responseuni.data.items;
        let branchlist = data.map((p) => ({
          value: p.id,
          label: p.name || p.address || (p.area && p.area.name) || "-",
        }));
        this.setState({ branchlist });
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  }

  handleValidSubmit = async () => {
    this.setState({ loading: true });

    const { id, branchId, merchantId, imageUrl, isImageChanged, ...data } =
      this.state;

    let response;
    try {
      if (id) {
        if (!isImageChanged) delete data.imageUrl;
        else data["imageUrl"] = this.idFileBase64;

        response = await this.engine.updateItem(this.pathname, id, data);
      } else {
        const { title, name, description, merchantId, branchId } = this.state;
        const postData = {
          imageUrl: this.idFileBase64, // Only set the new image data
          title,
          description,
          name,
          merchantId,
          branchId,
        };
        if (branchId === "") delete postData.branchId;

        response = await this.engine.saveItem(this.pathname, postData);
      }

      if (response && (response.status === 201 || response.status === 200)) {
        this.props.history.push("/admin/" + this.pathname);
      }
    } catch (err) {
      if (merchantId === "") {
        alert(strings.select + " " + strings.merchant); // Replace with a more sophisticated error handling
      }
      // else if ( branchId === "") {
      //     alert('Please select a branch'); // Replace with a more sophisticated error handling
      // }
      else if (imageUrl === "") alert("Please add a picture");
      // This block will handle exceptions, including the BadRequestException
      else if (err.response && err.response.status === 400) {
        // Handle specific error with detailed message
        alert("Error: " + err.response.data.message.join(", "));
      } else {
        // Handle general errors
        alert("An unexpected error occurred: " + err.message);
      }
    }

    this.setState({ loading: false });
  };

  onChangePic(e) {
    if (!e.target.files[0]) {
      return; // No file selected, return early
    }

    Utilites.getFileBase64(e.target.files[0], (result) => {
      this.setState({ imageUrl: result, isImageChanged: true });
      this.idFileBase64 = result; // Only update if new file is selected
    });
  }

  render() {
    const {
      loading,
      isLoading,
      name,
      description,
      merchantId,
      branchId,
      merchantlist,
      branchlist,
      id,
    } = this.state;
    const merchantIdFromSession = sessionStorage.getItem("merchantId");

    if (isLoading) {
      return this.renderProgress();
    }

    return (
      <div className="content english">
        <h4>{strings.information}</h4>
        <Row>
          <Col md="12">
            <AvForm
              onValidSubmit={() => this.handleValidSubmit()}
              className="form-horizontal"
              id="TypeValidation"
            >
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">{strings.information}</CardTitle>
                </CardHeader>
                <CardBody>
                  {!id && !merchantIdFromSession && (
                    <SelectRow
                      label={strings.merchant}
                      name="merchantId"
                      defaultValue={merchantId}
                      data={merchantlist}
                      changeInput={(e) => {
                        const selectedMerchantId = e.value;
                        this.setState(
                          { merchantId: selectedMerchantId },
                          () => {
                            this.fetchBranches(selectedMerchantId);
                          }
                        );
                      }}
                    />
                  )}
                  {!id && (
                    <SelectRow
                      label={strings.branch}
                      name="branchId"
                      defaultValue={branchId}
                      data={branchlist}
                      changeInput={this.changeInput.bind(this)}
                    />
                  )}
                  <FormRow
                    label={strings.name}
                    name="name"
                    data={name}
                    changeInput={this.changeInput.bind(this)}
                  />
                  <FormRow
                    label={strings.description}
                    name="description"
                    data={description}
                    changeInput={this.changeInput.bind(this)}
                  />

                  <Row>
                    <Label sm="2">{strings.picture}</Label>
                    <Col sm="5">
                      <FormGroup>
                        <ImageUpload
                          placeholder={
                            this.state.imageUrl ||
                            `${strings.select} ${strings.picture}`
                          }
                          labelupload={`${strings.select} ${strings.picture}`}
                          onChange={(e) => this.onChangePic(e)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter className="text-center">
                  <ButtonLoader color="primary" loading={loading}>
                    {strings.save}
                  </ButtonLoader>
                </CardFooter>
              </Card>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}
